import WpBaseComponent from '../wp-base-component';
import Component from 'vue-class-component';
import { Order } from 'web-platform-help-desk-core-frontend-ui/src/HelpDesk/order-info';
import { IHelpDeskService, INotificationService, HelpDeskSymbols, NotificationSymbols } from 'web-platform-help-desk-core-frontend-ui';

@Component({
    template: require("./hd-admin.html")
})
export default class HDAdmin extends WpBaseComponent {
    protected _service!: IHelpDeskService;
    protected _notificationService!: INotificationService;

    protected Tab: number = 0;
    protected Align: string = "center";

    TableLoading: boolean = true;
    OrderToRefund: Order | null = null;
    OrderToView: Order | null = null;
    DeclineReason: string = "";

    TableHeaders: Array<Object> = [
        { align: this.Align, text: "ID", value: "id" },
        { align: this.Align, text: "Код заказа", value: "orderCode" },
        { align: this.Align, text: "Телефон", value: "userPhone", sortable: false },
        { align: this.Align, text: "Email", value: "userEmail", sortable: false },
        { align: this.Align, text: "Дата создания", value: "createdDate" },
        { align: this.Align, text: "Заявление", value: "applicationFileName", sortable: false },
        { align: this.Align, text: "Сумма", value: "sum" },
        { align: this.Align, text: "Действия", value: "actions", sortable: false },
    ];

    TableItems: Array<Object> = [];

    created(): void {
        this._service = this.GlobalService.Get<IHelpDeskService>(HelpDeskSymbols.HelpDeskService);
        this._notificationService = this.GlobalService.Get<INotificationService>(NotificationSymbols.NotificationService);
    };

    async mounted(): Promise<void> {
        await this.LoadRefunds();
    };

    TabSwitched(): void {
        this.LoadRefunds();
    };

    // Загрузить список заявок на возврат
    async LoadRefunds(): Promise<void> {
        this.TableLoading = true;
        this.TableItems.length = 0;
        let query = await this._service.GetRefundsAsync(this.Tab);
        if (!query.Success && !query.Data)
            return this._notificationService.Error("Загрузка заявок", query.ErrorMessage!);
        this.TableItems = query.Data!;
        this.TableLoading = false;
    };

    async ApproveRefund(order?: Order): Promise<void> {
        let orderToRefund = order ? order : this.OrderToRefund;
        if (orderToRefund) {
            let query = await this._service.ApproveRefundAsync(orderToRefund);
            console.log(query);
        };
    };

    async DeclineRefund(order?: Order): Promise<void> {
        let orderToRefund = order ? order : this.OrderToRefund;
        if (orderToRefund) {
            let query = await this._service.DeclineRefundAsync(orderToRefund);
            console.log(query);
        };
    };
};